<div class="main" qa="prebidSuccess">
  <div *nzModalTitle class="top">
    <div class="title">
      <p>
        <b>{{ data.name }}</b>
      </p>
    </div>
  </div>
  <div class="middle">
    <div class="main__message">Endpoint is successfully generated</div>
  </div>
  <div class="bottom">
    <div class="main__inputs">
      <div
        class="form-group"
        *ngIf="
          data.connectionType === 'prebid' &&
          this.data.isShowPartnerNameForPrebid
        "
      >
        <label for="hostPreBid">Partner name</label>
        <input
          nz-input
          class="form-control"
          disabled
          id="partnerName"
          name="partnerName"
          [(ngModel)]="data.partnerName"
        />
      </div>
      <div
        class="form-group"
        *ngIf="
          data.connectionType === 'prebidJs' &&
          this.data.isShowPartnerNameForPrebidJS
        "
      >
        <label for="hostPreBid">Partner name</label>
        <input
          nz-input
          class="form-control"
          disabled
          id="partnerName"
          name="partnerName"
          [(ngModel)]="data.partnerName"
        />
      </div>
      <div class="form-group">
        <label for="seatPreBid">Seat</label>
        <input
          nz-input
          class="form-control"
          disabled
          id="seatPreBid"
          name="seatPreBid"
          [(ngModel)]="data.seat"
        />
      </div>
      <div class="form-group">
        <label for="tokenPreBid">Token</label>
        <input
          nz-input
          class="form-control"
          disabled
          id="tokenPreBid"
          name="tokenPreBid"
          [(ngModel)]="data.token"
        />
      </div>
    </div>
  </div>
  <div *nzModalFooter class="btn-block">
    <button nz-button nzType="primary" (click)="closeDialog()" qa="closePrebidModal">Close</button>
  </div>
</div>
